import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  CircularProgress,
} from "@mui/material";

function QuickWordDeleteDialog({
  open,
  onClose,
  selectedCommand,
  onDelete,
  isProcessing,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Command</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the command &quot;
          {selectedCommand?.id}&quot;? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onDelete}
          color="error"
          disabled={isProcessing === "delete"}
        >
          Delete
          {isProcessing === "delete" && (
            <CircularProgress size={20} sx={{ ml: 1 }} />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default QuickWordDeleteDialog;
